var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7917 2.12501H12.4375C12 0.916672 10.8542 0.0416718 9.5 0.0416718C8.14583 0.0416718 7 0.916672 6.5625 2.12501H2.20833C2.0625 2.12501 1.92708 2.13542 1.79167 2.16667C1.38542 2.25001 1.02083 2.45834 0.739583 2.73959C0.552083 2.92709 0.395833 3.15626 0.291667 3.40626C0.1875 3.64584 0.125 3.91667 0.125 4.20834V18.7917C0.125 19.0729 0.1875 19.3542 0.291667 19.6042C0.395833 19.8542 0.552083 20.0729 0.739583 20.2708C1.02083 20.5521 1.38542 20.7604 1.79167 20.8438C1.92708 20.8646 2.0625 20.875 2.20833 20.875H16.7917C17.9375 20.875 18.875 19.9375 18.875 18.7917V4.20834C18.875 3.06251 17.9375 2.12501 16.7917 2.12501ZM8.45833 13.7604L6.98958 15.2396L3.25 11.5L6.98958 7.76042L8.45833 9.23959L6.19792 11.5L8.45833 13.7604ZM9.5 3.42709C9.07292 3.42709 8.71875 3.07292 8.71875 2.64584C8.71875 2.21876 9.07292 1.86459 9.5 1.86459C9.92708 1.86459 10.2812 2.21876 10.2812 2.64584C10.2812 3.07292 9.92708 3.42709 9.5 3.42709ZM12.0104 15.2396L10.5417 13.7604L12.8021 11.5L10.5417 9.23959L12.0104 7.76042L15.75 11.5L12.0104 15.2396Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.bce1cf67.svg";
export { ForwardRef as ReactComponent };